export default {
  "site.title": "Hipobuy.yachts",
  "site.tagline": "Guide Complet du Hipobuy Spreadsheet",
  "nav.home": "Accueil",
  "nav.guides": "Guides",
  "nav.comparatifs": "Comparatifs",
  "nav.blog": "Blog",
  "nav.faq": "FAQ",
  "hero.h1.line1": "Hipobuy Spreadsheet",
  "hero.h1.line2": "Guide Complet 2026",
  "hero.subtitle": "Découvrez comment utiliser le hipobuy spreadsheet pour améliorer votre organisation, automatiser vos processus et analyser vos résultats comme un expert.",
  "hero.cta.primary": "Hipobuy Spreadsheet",
  "hero.cta.secondary": "Buy It Now",
  "hero.trust.line1": "Utilisé par des utilisateurs avancés",
  "hero.trust.line2": "Compatible Google Sheets & Excel",
  "hero.trust.line3": "Mise à jour 2026",
  "hero.dropdown.placeholder": "Choisissez une catégorie...",
  "categories.title": "Nos Catégories Mode",
  "categories.subtitle": "Explorez notre collection complète de vêtements et accessoires tendance",
  "articles.title": "Hipobuy Spreadsheet",
  "articles.subtitle": "Guides SEO & Comparatifs 2026",
  "articles.readmore": "Lire l'article",
  "about.tag": "À Propos",
  "about.title.line1": "Centralisez",
  "about.title.line2": "Vos Données",
  "about.title.line3": "Hipobuy",
  "about.desc1": "Le hipobuy spreadsheet est conçu pour les professionnels qui souhaitent centraliser leurs données, automatiser le suivi et optimiser leurs décisions grâce à une structure claire et intuitive.",
  "about.desc2": "Notre plateforme vous permet de gérer efficacement vos processus, d'analyser vos performances en temps réel et de prendre des décisions éclairées basées sur des données fiables.",
  "about.advantage": "AVANTAGE",
  "about.quote": "Cet outil a complètement transformé notre façon de suivre et d'optimiser nos processus. Une solution vraiment indispensable pour les équipes modernes.",
  "about.name": "Sophie Laurent",
  "about.role": "Responsable Marketing Digital",
  "cta.title.line1": "Optimisez",
  "cta.title.line2": "Vos Résultats",
  "cta.title.line3": "Maintenant",
  "cta.heading": "Rejoignez Kaspreadsheet",
  "cta.description": "Accédez à la plateforme complète et découvrez tous les outils dont vous avez besoin pour transformer votre gestion de données. Des solutions avancées pour des résultats exceptionnels.",
  "cta.button": "Acheter Maintenant",
  "testimonial.tag": "Témoignage",
  "testimonial.title.line1": "Ce que disent",
  "testimonial.title.line2": "nos utilisateurs",
  "testimonial.quote": "Depuis que j'utilise le hipobuy spreadsheet, ma productivité a augmenté de 40%. L'interface est intuitive et les fonctionnalités d'automatisation sont exactement ce dont j'avais besoin pour gérer mes projets efficacement.",
  "testimonial.author": "Marc Dubois",
  "testimonial.company": "Fondateur, DataOptima",
  "testimonial.prev": "Précédent",
  "testimonial.next": "Suivant",
  "footer.description": "Votre guide complet pour maîtriser le hipobuy spreadsheet et optimiser votre workflow en 2026.",
  "footer.address": "Adresse",
  "footer.phone": "Téléphone",
  "footer.email": "Email",
  "footer.address.line1": "128 Rue de la Paix",
  "footer.address.line2": "75002 Paris, France",
  "footer.phone.value": "+33 1 45 67 89 10",
  "footer.email.value": "contact@hipobuy.yachts",
  "footer.copyright": "© 2026 Hipobuy.yachts. Tous droits réservés.",
  "footer.security": "Sécurité",
  "footer.faq": "FAQ",
  "footer.contact": "Contact"
}